import ScoreInput from './ScoreInput.component';

export default ScoreInput;
